export const headers = {headers: {Authorization: `dd4f5083628121e92148d3deee00915847f20fbf7a55f9ffdcc9844899af35a7`}};
export const REST_BASE_URL = 'https://onlineservices.buscapk.es/zV3BDl7hE3eRfQjzA0qVYrAKmy20vtpf8g58PK9Q17TwQqO6X9smavS9q661LleY/';
export const ENTITLEMENT_ID = 'search';